import moment from "moment";
import ApiService from "../services/ApiService";
interface Design {
  id: number;
  code: string;
  cost: string;
  type: string;
  remark: string;
  totalMaterialCost: string;
  totalCuttingTime: string;
  totalCuttingCost: string;
  designCost: string;
  peelingCost: string;
  fusingCost: string;
  transportCost: string;
  otherExpCost: string;
  finalCost: string;
  grossCost: string;
  image: string;
  party: string;
  created_by: string;
}

const CancelToken = ApiService.getInstance().CancelToken;
let cancelRequest;
const Designs: Array<Design> = [];

const designObjClone = function () {
  return {
    id: 0,
    code: "",
    cost: "",
    type: "",
    remark: "",
    totalMaterialCost: "",
    totalCuttingTime: "",
    totalCuttingCost: "",
    designCost: "",
    peelingCost: "",
    fusingCost: "",
    transportCost: "",
    otherExpCost: "",
    finalCost: "",
    grossCost: "",
    image: "",
    party: "",
    created_by: "",
  };
};
const jsonToInterface = function (item: any) {
  const newItem: Design = designObjClone();
  newItem.id = item.id;
  newItem.code = item.code;
  newItem.cost = item.cost;
  newItem.type = item.type;
  newItem.remark = item.remark;
  newItem.totalMaterialCost = item.totalMaterialCost;
  newItem.totalCuttingTime = item.totalCuttingTime;
  newItem.totalCuttingCost = item.totalCuttingCost;
  newItem.designCost = item.designCost;
  newItem.peelingCost = item.peelingCost;
  newItem.fusingCost = item.fusingCost;
  newItem.transportCost = item.transportCost;
  newItem.otherExpCost = item.otherExpCost;
  newItem.finalCost = item.finalCost;
  newItem.grossCost = item.grossCost;
  newItem.image = item.image;
  newItem.party = item.party;
  newItem.created_by = item.created_by;
  return newItem;
};

const getCountOfData = function () {
  return new Promise((res, rej) => {
    if (typeof cancelRequest != typeof undefined) {
      cancelRequest.cancel("Operation canceled due to new request.");
    }
    cancelRequest = CancelToken.source();
    ApiService.getWithoutSlash(`dashboard/count/`, cancelRequest)
      .then(function (response) {
        const resObj: any = {
          data: [],
        };
        if (response.data) {
          resObj.data = response.data
        }
        res(resObj);
      })
      .catch((error) => rej(error));
  });
};

const getLast6MonthsCount = function (moduleName) {
  return new Promise((res, rej) => {
    ApiService.getWithoutSlashNoCancel(`dashboard/last-items/count/${moduleName}/`)
      .then(function (response) {
        const resObj: any = {
          data: [],
        };
        if (response.data) {
          resObj.data = response.data
        }
        res(resObj);
      })
      .catch((error) => rej(error));
  });
}

const getProductionStatus = function () {
  return new Promise((res, rej) => {
    ApiService.getWithoutSlashNoCancel(`dashboard/production/status`)
      .then(function (response) {
        const resObj: any = {
          data: [],
        };
        if (response.data) {
          resObj.data = response.data
        }
        res(resObj);
      })
      .catch((error) => rej(error));
  });
}

const jsonToInterfaceDesign = jsonToInterface;
const getEmptyObjOfDesign = designObjClone;
export {
  Design,
  getCountOfData,
  jsonToInterfaceDesign,
  designObjClone,
  getEmptyObjOfDesign,
  getLast6MonthsCount,
  getProductionStatus
};

export default Designs;
